export class TiposContratacoes {

    id: number;
    codigoTipoContratacao: string;
    descricaoTipoContratacao: string;
}